import React, { useEffect, useLayoutEffect, useState } from "react";
import { Row, Col, message } from "antd";
import { useParams, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ResetPasswordForm from "../../../forms/ResetPasswordForm";
import schema from "../../../schemas/resetPasswordSchema";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { resetPasswordSaga } from "./saga";
import * as selectors from "./selectors";
import { useAuth } from "../../../contexts/auth/index";
import "./style.css";
/* const styles = {
  loginPage: {
    height: "100%",
  },

  bgLogin: {
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "60%",
  },
}; */
const ResetPasswordPage = () => {
  const auth = useAuth();
  const history = useHistory();
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: resetPasswordSaga });
  const dispatch = useDispatch();
  const { token } = useParams();

  const loading = useSelector(selectors.selectLoading);
  const error = useSelector(selectors.selectError);
  const successMessage = useSelector(selectors.selectMessage);

  useEffect(() => {
    if (error && error !== "") {
      message.error(error);
      setTimeout(() => {
        dispatch(actions.initializeError());
      }, 1000);
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (successMessage && successMessage !== "") {
      message.success(successMessage);
    }
  }, [successMessage]);

  const handleSuccess = () => {
    history.replace("/");
    auth.fetchLoggedInUser();
  };

  const submitForm = (submitted) => {
    dispatch(
      actions.resetPassword({
        data: { password: submitted.password },
        token,
        onSuccess: handleSuccess,
      })
    );
  };

  const [col, setCol] = useState(12);

  useLayoutEffect(() => {
    function updateCol() {
      if (window.innerWidth < 660) setCol(24);
      else setCol(12);
    }
    window.addEventListener("resize", updateCol);
    updateCol();
    return () => window.removeEventListener("resize", updateCol);
  }, []);
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      passwordConfirm: "",
    },
    resolver: yupResolver(schema),
  });

  return (
    <Row gutter={32} style={{ height: "100%" }}>
      <Col span={col} className="bgImage">
        <div
          /*  style={{
            ...styles.bgLogin,
            backgroundImage: `url(${loginBg})`,
            height: "100%",
          }} */
          className="bgResetPassword"
        />
      </Col>
      <Col span={col}>
        <ResetPasswordForm
          control={control}
          errors={errors}
          onSubmit={handleSubmit(submitForm)}
          loading={loading}
        />
      </Col>
    </Row>
  );
};

export default ResetPasswordPage;
